// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import taskEntity from './entities/task.json';
import taskMenu from '../pages/task/menu.json';
import taskFullForm from '../pages/task/forms/full.json';
import taskContextForm from '../pages/task/forms/context.json';
import taskMiniForm from '../pages/task/forms/mini.json';
import taskLookupForm from '../pages/task/forms/lookup.json';
import taskTableView from '../pages/task/views/table.json';
import taskStagesView from '../pages/task/views/stages.json';
import taskCardsView from '../pages/task/views/cards.json';
import taskInlineView from '../pages/task/views/inline.json';
import taskBacklogView from '../pages/task/views/backlog.json';
import taskSplitView from '../pages/task/views/split.json';
import taskCalendarView from '../pages/task/views/calendar.json';
import taskDashboardView from '../pages/task/views/dashboard.json';
import taskByareaView from '../pages/task/views/byarea.json';
import taskByteamView from '../pages/task/views/byteam.json';
import taskTracesView from '../pages/task/views/traces.json';
import taskTmatrixView from '../pages/task/views/tmatrix.json';

/** Тип запису «Завдання» зі сторінками пакета: меню, форми та подання з pages/task/. */
export const taskDefinition: IRecordTypeDefinition = {
  ...taskEntity,
  views: assembleViewSet({
      table: taskTableView,
      stages: taskStagesView,
      cards: taskCardsView,
      inline: taskInlineView,
      backlog: taskBacklogView,
      split: taskSplitView,
      calendar: taskCalendarView,
      dashboard: taskDashboardView,
      byarea: taskByareaView,
      byteam: taskByteamView,
      traces: taskTracesView,
      tmatrix: taskTmatrixView,
  }),
  form: taskFullForm,
  forms: { full: taskFullForm, context: taskContextForm, mini: taskMiniForm, lookup: taskLookupForm },
  menu: taskMenu,
} as IRecordTypeDefinition;
